import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BRAND_NAME } from "@constants";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { HomeBroadbandPrequalAddress } from "@features/home/common/HomeBroadbandPrequalAddress/HomeBroadbandPrequalAddress";
import { Email } from "@features/email/Email";

interface IParams {
    isWrapped?: boolean;
    prequal: IEirSalesPrequal;
    persistBroadbandEmailSent?: boolean;
    handleChangeAddress(): void;
}

export const HomeBroadbandEmail = (props: IParams) => {
    const { prequal, isWrapped, persistBroadbandEmailSent, handleChangeAddress } = props;
    const { t } = useTranslation(["home", "glossary"]);

    return (
        <Stack alignItems="center" maxWidth={571} padding={2} spacing={2}>
            <Typography align="center" color="secondary" variant="h1">
                {t("home:broadbandNotAvailable", { brand: BRAND_NAME })}
            </Typography>
            <HomeBroadbandPrequalAddress address={prequal.address} handleChangeAddress={handleChangeAddress} />
            <Box paddingTop={2}>
                <Typography align="center" color="secondary" paddingBottom={2} variant="large">
                    {t("home:stayTuned")}
                </Typography>
                <Email
                    eircode={prequal.address.eircode as string}
                    isWrapped={isWrapped}
                    persistBroadbandEmailSent={persistBroadbandEmailSent}
                />
            </Box>
        </Stack>
    );
};
